import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  isMobileView: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isTabletView: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isDesktopView: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.setupViewports();
    }
  }

  private setupViewports(): void {
    const update = () => {
      this.isMobileView.next(window.innerWidth <= 767);
      this.isTabletView.next(window.innerWidth >= 768 && window.innerWidth <= 1199);
      this.isDesktopView.next(window.innerWidth >= 1200);
    };
    update();
    window.addEventListener('resize', update);
  }

  get isAndroidDevice(): boolean {
    if (!isPlatformBrowser(this.platformId)) return false;
    return /Android|webOS|BlackBerry|IEMobile/i.test(navigator.userAgent);
  }
}